import React from "react";
import { Box, Card, Typography } from "@material-ui/core";
import { Line } from "react-chartjs-2";
import styles from "./AnalyticalDashboard.module.scss";
import NoUserFound from "../../assets/NoUserFound.svg";
import moment from "moment";

const options = {
  plugins: {
    legend: {
      display: false,
    },
  },
  elements: {
    point: {
      radius: 5,
    },
  },

  borderRadius: 4,
  tooltips: { enabled: true },
  scales: {
    x: {
      grid: {
        display: false,
      },
      title: {
        display: true,
        text: "(Number of Commands) x (Time)",
        padding: 10,
      },
      ticks: {
        color: "#A0A0A0",
      },
    },
    y: {
      ticks: {
        color: "#A0A0A0",
      },
    },
  },
};

const RewardedPeerfives = (props) => {
  const { engagementReport } = props;
  const dataPoints = [];
  const months = [];
  engagementReport.report.map((item, i) => {
    dataPoints.push(item.engagement_count);
    months.push(moment(item._id.month, "MM").format("MMM"));
  });

  const data = {
    labels: months,
    datasets: [
      {
        data: dataPoints,
        backgroundColor: "white",
        borderWidth: 3,
        borderColor: "#FF7269",
        fill: false,
        tension: 0.2,
      },
    ],
  };
  return (
    <Card {...props} className={styles.commanSummeryContainer}>
      <div className={styles.headerContainer}>
        <Typography className={styles.heading}>PeerFives Engagement</Typography>
      </div>
      {engagementReport.report.length <= 0 ? (
        <div className={styles.noDataDiv}>
          <img src={NoUserFound} alt="No Data Found" />
          <Typography className={styles.noData}>
            No Peerfives Engagement Found
          </Typography>
        </div>
      ) : (
        <Box className={styles.graphContainer}>
          <Line data={data} options={options} />
        </Box>
      )}
    </Card>
  );
};

export default RewardedPeerfives;
